<mat-dialog-content class="breed-dialog">
    <mat-form-field class="search-field">
        <input matInput [(ngModel)]="searchTerm" (input)="filterBreeds()" placeholder="Search breed...">
    </mat-form-field>

    <div *ngIf="groupedBreeds.length === 0" class="no-breeds">
        No breeds found.
    </div>

    <div *ngFor="let group of groupedBreeds">
        <h3 class="group-header">{{ group.letter }}</h3>
        <mat-list>
            <mat-list-item *ngFor="let breed of group.breeds" (click)="selectBreed(breed)">
                {{ breed.name }}
            </mat-list-item>
        </mat-list>
    </div>
</mat-dialog-content>
